import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const EnvWarning = () => {
  return (
    <Box
        sx={{
            position: "fixed",
            top: "75px",
            right: "13px",
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
            width: "190px",
            backgroundColor: "error.main",
            zIndex: 1002,
            padding: "5px 0",
            opacity: "0.8",
            borderRadius: "3px"
        }}>
      <Typography variant="subtitle1" color="common.white" style={{fontSize: "12px"}}>
        Detta är ingen produktionsmiljö
      </Typography>
    </Box>
  );
};

export default EnvWarning;
